export function getValueFromArray(
  arr: Array<object>,
  idToSearch: number,
  toReturn: any
) {
  const _ele: any = arr.find((el: any) => el.id === idToSearch);
  if (_ele) {
    return _ele[toReturn];
  }
}
